import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_222: DocMigration = {
  maxSchemaVersion: "0.0.222",
  description: "Set operation type to fixed for circle windows and set default window pane split spacing",
  apply(json: any) {
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "WINDOW_CATALOG_SETTINGS") {
        for (const typeId in setting.windowTypes) {
          const window = setting.windowTypes[typeId];
          if (window.operationType === "SINGLE_HUNG" || window.operationType === "DOUBLE_HUNG") {
            // fix circle window operation type
            if (window.shape === "CIRCLE") {
              window.operationType = "FIXED";
            } else {
              // add default values for window pane split spacing
              window.paneSplitParam = 0.5;
              window.paneSplitParamNormalized = true;
            }
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_222;
